const ko = {
    requirementList: '요구 사항 목록',
    material: '재료 관리',
    purchase: '구매',
    prod: '생산',
    finance: '금융',
    sale: '사업',
    materialStatus: '재료 관리 검토 상태',
    purchaseStatus: '구매 검토 상태',
    prodStatus: '생산 검토 상태',
    financeStatus: '재무 검토 상태',
    saleStatus: '사업 검토 상태',
    materialDesc: '재료 관리 검토 노트',
    purchaseDesc: '구매 리뷰 메모',
    prodDesc: '생산 검토 노트',
    financeDesc: '재무 감사 ​​노트',
    saleDesc: '사업 리뷰 노트',

    commodity: '제품',
    commodityStatus: '제품 심사 상태',
    commodityDesc: '제품 심사 참고 사항',

    passed: '통과',
    notPass: '실패',
    approvalTip: '리뷰 메모를 입력하세요',
    listSearchTip: '검색할 번호, 설명, 제품 정보를 입력하세요',

    number: '숫자',
    bomAmount: '사용량',
    requireCount: '필요한 수량',
    itemCountInfo: '필요한 항목 수',
    materialProgress: '재료 준비 진행 상황',
    mrd: '자료수집시간 요청',
    plMrd: '자료수집에 필요한 시간을 입력해 주세요',
    mcPre: '자재 관리 예비 부품 수량',
    bomData: '표준 수량의 총 개수',
    estimatedCost: '예상 비용',
    passStatus: '승인 상태',

    errorTip: '오류 팁',
    errorDesc: '테이블에 데이터 이상이 있습니다. 제출하기 전에 수정하지 않으시겠습니까? ',
    noRepl: '대체 재료가 없습니다',
    selectRepl: '대체 재료 선택',
    allCount: '총 수량이 반올림되었습니다. 실제 상황에 따라 총 사용량을 수정할 수 있습니다',

    matchBom: 'Bom 테이블 일치',
    editQuantity: '수량 수정',
    matchInventory: '인벤토리 매치',
    alrPreOutNum: '이미 사전 출고된 수량',
    preOut: '사전 아웃',
    confirmPickOut: '이번 사전 출고 수량이 실제 출고 가능 수량보다 적으면 실제 출고 가능 수량을 기준으로 자재 출고서를 생성합니다. 사전 출고 주문을 생성하시겠습니까?',
    confirmPro: '재료 데이터 확인',
    prePickOut: '사전 출고 주문 생성',
    prePickOutNum: '이번 사전 출고 수량',
    actualOutNum: '실제 출고 가능 수량',
    addDesc: '메모 추가',
    done: '완료',
    doneSuccess: '요구 사항 목록을 성공적으로 생성했습니다',
    doneSuccessTip: '요구사항 목록 {{ number }}이 생성되었으며, 해당 업체는 다음 단계로 진행됩니다',
    next: '다음 단계',
    previous: '이전 단계',
    requirementAdd: '요구 사항 목록 생성',
    selectPro: '제품 선택',
    searchPro: '제품 키워드 쿼리 입력',

    detail: '요구 사항 목록 세부 정보',
    orderDetail: '주문 세부 정보',

    purCount: '구매할 수량',
    purEdCount: '구매 도착 수량',
    preInCount: '사전 재고 수량',
    preOutCount: '사전 출력 수량',
    minPrice: '최소 단위 가격',
    maxPrice: '최대 단가',
    minCost: '최소 비용',
    maxCost: '최대 비용',
    supplierAndPrice: '공급업체 및 가격 선택',
    addPurDesc: '구매 설명 추가',

    notApproved: '아직 승인되지 않음',

    requirementAppInfo: '요구사항 목록 검토 정보',
    eps: '예상 온라인 날짜',
    plEps: '발사 예상 시간을 입력해 주세요',
    saveTemp: '템플릿 저장',
    saveTempSuccess: '템플릿이 성공적으로 추가되었습니다',
    useQuantity: '사용된 제품 수량',
    addConfirm: '이 요청을 추가하시겠습니까? ',
    selectProdPro: '생산 마스터 선택',
    plSelectProdPro: '생산할 마스터 파트를 선택하세요',
    product: '마더 피스',
    prodCount: '생산 수량',
    plProdCount: '생산 수량을 입력해주세요',
    desc: '요구 사항 목록 메모',
    plDesc: '요구 사항 목록 메모를 입력하세요',
    plSubPro: '하위 구성 요소 정보 선택',
    tempSuccess: '템플릿이 성공적으로 생성되었습니다',
    validError: "검증 오류",
    addRequirement: '요구 사항 추가',
    total: '총',
    success: '성공',
    failed: '실패',
    exportExcel: 'Excel 내보내기',
    requirementCreate: '요구사항 목록 생성',
    mainInfo: "주요 정보",
    flow: "승인 흐름",
    delSubTip: '선택한 하위 구성 요소를 삭제하시겠습니까? 삭제하면 복구할 수 없습니다',
    syncClearRequirementItems: '요구사항 항목 동기화 삭제',
    syncClearRequirementItemsTip: '현재 요구사항 목록의 모든 요구사항 항목을 삭제하시겠습니까? 삭제 후에는 복구할 수 없습니다',
    delOrderItemTip: '해당 자재 출고 전표를 삭제하시겠습니까?',
    delPurchaseOrderItemTip: '해당 구매 주문을 삭제하시겠습니까?',
    selectAll: '모두 선택',
    oked: '통과',
    pending: '보류 중',
    rejected: "거부됨",
    rejectTip: '이 요구 사항 목록을 거부하시겠습니까? 거부한 후 비즈니스 운영의 이전 단계로 돌아갑니다',
    rejectReason: '거부 사유',
    rejectReasonRequired: '거부 사유를 입력하세요',
    rejectReasonPlaceholder: '거부하는 이유를 자세히 설명해 주세요...',
    rejectReasonMaxLength: '거부 사유는 500자를 초과할 수 없습니다',
    closeTip: '이 위시리스트를 보관하시겠습니까? 보관 후에는 데이터를 변경할 수 없습니다',
    supplier: "공급자",
    ert: '예상 배달 시간',
    supplierPriceNo: '공급업체 가격이 없습니다',
    surOk: '구매 주문이 성공적으로 추가되었습니다. 페이지를 필터링하여 확인하세요',
    surSure: '구매 가능한 데이터가 있는지 확인해 주세요',
    reject: '거부하다',
    close: '닫기',
    saleNum: '판매 수량',
    prNum: '생산량',
    plPrNum: '생산 수량을 입력해주세요',
    orderAlready: '주문이 수요 양식을 생성했습니다',
    orderDate: "주문 날짜",
    pricePreview: '제품 가격 미리보기',
    endError: "이 주문이 완료되었는지 확실합니까?",
    plSeSupplier: "공급업체 선택",
    plPlacePrice: "주문 가격을 선택하세요",
    noPurchaseTip: "구매 가능한 데이터가 없습니다",
    okPurchase: "구매 확인",

    onKeyQutote: "원클릭 문의",
    subQutote: "분할 문의",
    onKeyPrice: "원클릭 가격 조회",
    subPrice: "분할 가격 조회",
    onKeyPurchese: "클릭 한 번으로 사전 주문서 생성",
    sendQutote: "문의서 발송됨",
    sendQutotePro: "{{len}} 개 항목에 대한 가격 조회 요청이 발송되었습니다",
    ddl: '마감 시간',
    noSupplier: "질문서를 보낼 수 있는 공급업체가 없습니다.",
    qutoteSednFail: "질문서 발송 실패",
    autoPurcheseSucc: '자동 구매서 생성 성공, 일부 자재에 유효한 견적이 없으면 구매서 생성 불가',
    supplierProgress: '공급업체 피드백 진행률',
    unRead: '읽지 않음',
    read: '읽음',
    unPriced: "쿼트 대기",
    resolved: "쿼트됨",
    qutotationProgress: "가격 조회서 진도 상세 정보",
    matInfo: '재료 정보',
    requirementInfo: '견적 정보',
    requirementHelp: '지원 쿼트',
    supplierQuote: '공급업체 견적',
    status: '상태',
    days: '공급 주기',
    mpq: "최소 포장",
    supplierTime: "제재 시간",
    edit: '편집',
    resped: '피드백됨',
    unResp: '피드백 없음',
    rulePrice: "계약가격",
    ruleDays: "계약 공급 주기",
    ruleMpq: "계약 최소 포장",
    price: "가격",
    inputPrice: "가격을 입력하십시오.",
    priceTip: "팁: 오퍼가 계약가보다 높으면 오퍼가 무효가 될 수 있습니다.",
    inputDays: '공급 주기를 입력하십시오.',
    daysTip: "팁: 공급 주기가 계약 공급 주기보다 크면 견적이 무효화될 수 있습니다.",
    mpqTip: "팁: 최소 포장 수량이 계약 최소 포장 수량보다 크면 견적이 무효가 될 수 있습니다.",
    inputSuppTime: "제품 시간을 입력하십시오.",
    addSuppQutoteTip: "이 공급업체는 이미 가격조회서가 있으므로 새로 추가할 필요가 없습니다.",
    addSuppQutote: '신규 공급업체 견적',

    inputMpq: "최소 포장을 입력하십시오",
    ddlTime: "가장 늦은 배송 시간",
    inputDdlTime: "가장 늦은 배송 시간을 입력하십시오.",
    ddlTimeTip: "힌트: 늦어도 납품 시간이 원료 공급 시간을 초과하면 시간 초과로 인해 오퍼가 무효가 될 수 있습니다.",
    prevDMrd: '예상 배송 시간',
    deadline: "늦은 제출 시간",

    nuRead: "읽지 않음",
    timedOut: "기한이 지났습니다",
    day: "하늘",
    hour: "시간",
    purTip: "사전 구매 주문을 생성하시겠습니까?",
    purContent: "이렇게 하면 사전 구매 주문이 자동으로 생성됩니다.",

    salePrice: "판매 금액",
    mateCost: "재료 비용",
    notCount: "계산되지 않음",
    netProfit: "순이익",
    goPur: "구매서 생성",

    lazyQuota: '연지 견적',
    lazyQuotaSuc: '연지 견적 성공',
    lazyQuotaErr: '연지 견적 실패',
    lazyTime: '지연할 기간을 선택하거나 입력합니다.',
    curLazy: '현재 견적 마감 시간',

    notSelect: '일부 재료에 유효한 견적이 없습니다. 각 재료에 유효한 견적이 있는지 확인한 후 통과하십시오.',
    notSelectTip: '다음 재료에 유효한 견적이 존재하지 않습니다.',
    purchaseProgress: "구매서 진행률",
    quotationProgress: "문의서 발송 진도",
    noQuotationTip: '빨간색 재료에 유효한 견적이 없습니다.',
    searchPlaceHolder: '공급업체 또는 제품 정보 쿼리 입력',
    allQuotation: '모두 문의서',
    purchaseOrders: '구매 주문서',
    prePurchaseOrders: '사전 구매서',
    preview: '미리보기',
    toGen: '생성할 예정',

    unApprove: '보류 중',
    approved: '승인됨',
    timed: '이미 만료됨',
    updatePrice: '쿼트 수정',
    rePrice: '재견적',
    quotation: '견적 승인',
    reSelect: '수동 선택',
    selected: '선택',
    reSelecteDone: '다시 선택됨',
    reSelecteFail: '재선택 실패',
    createPreOutInventory: '출고 전 주문서 생성',
    createPreOutInventoryCon: "자재 인출 출고 주문을 생성하시겠습니까?",
    createPreOutInventorySuccess: '출고 전 주문서 생성 성공',
    createPreOutInventoryFail: '사전 출고 양식 생성 실패',
    noPreOutInventory: '출고할 재료가 없다',
    pleaseSelect: '재료를 선택하십시오.',
    preOutInventory: '출고 전 명세서',
    goodsName: '재료 이름',
    availableQuantity: '출고 가능 수량',
    outboundType: '출고장 유형',
    inCount: '입고 수량',
    outCount: '출고 수량',
    shouldOutCount: '출고 예정 수량',
    actualOutCount: '실출고 수량',
    requirmentQuantity: '요구사항 수량',
    preReadyGood: '재고 있는 재료는 출고 필요 없음',
    outInventory: '출고 명세서',
    notQuo: "견적 불필요",
    notPur: "구매 불필요",
    curMrd: "현재 납기 시간",
    selMrd: "최종 납기 시간 선택",
    finalMrd: "최종 납기 시간",
    mrdEdit: "예상 납기 시간 조정",
    quoEdit: "문의서 수정",
    closeReq: "수요서 닫기",
    editNum: "수요 목록 수량 수정",
    plReqCount: "필요 수량을 입력하세요",
    plPurCount: "구매 필요 수량을 입력하세요",
    purCountErr: "구매 수량은 필요 수량보다 작아야 합니다",
    bomAmountErr: "유효한 BOM 수량을 입력하세요",
    quantityAndBomAmount: "수량과 사용량은 비어 있거나 0일 수 없습니다",
    skipStock: "재고 매칭 건너뛰기（예상 출고 안 함）",
    skipMerge: "동일한 자재 병합（동일한 자재 병합, 수량 합산）",
    finalPurQuantity: "최종 구매 수량",
    quotationTip: "견적 제출 후 수정 불가합니다. 견적을 제출하시겠습니까?",
    notAddCloseTip: "자재가 아직 추가되지 않았습니다. 닫으시겠습니까?",
    confirmAddProduct: "제품 정보 추가 확인",
    duplicateMaterialTip: "노란색으로 표시된 자재는 동일한 자재가 다른 곳에 있음을 나타냅니다",
    matching: "매칭 중...",
    documentGenerationFailed: "문서 생성 실패",
    printFailed: "인쇄 실패",
    pdfGenerationFailed: "PDF 생성 실패",
    requirementListAll: "요구사항 목록_전체",
    exportMatchResult: "매칭 결과 내보내기",

    // MultiPurchaseSteps 일괄 구매 주문
    multiPurchaseTitle: "일괄 구매 주문",
    selectSupplier: "공급업체 선택",
    matchProduct: "제품 일치",
    matchPrice: "가격 일치",
    generatePurchase: "구매 주문 생성",
    acceptPurchase: "구매 주문 수락",
    complete: "완료",
    nextStep: "다음",
    prevStep: "이전",
    tip: "팁",
    enterGenerateTip: "구매 주문 생성 단계에 들어가면 되돌릴 수 없습니다",
    confirmClose: "닫으시겠습니까?",
    closeTipContent: "구매 주문이 아직 생성되지 않았습니다. 닫으시겠습니까?",

    // MatchProduct 제품 일치
    oneClickAddProduct: "제품 일괄 추가",
    addingProduct: "제품 추가 중",
    processed: "처리됨:",
    productsWithoutPrice: "빨간색으로 표시된 자재는 공급업체 시스템에 존재하지 않습니다. 공급업체 시스템에 이 자재를 추가해야 합니다",
    noNeedAddProduct: "제품을 추가할 필요가 없습니다",
    noNeedAddProductDesc: "존재하지 않는 자재가 없습니다. 추가할 필요가 없습니다",
    supplierApiError: "공급업체 API 오류, 확인해주세요",
    productMatchFailed: "제품 일치 실패",
    productMatchFailedDesc: "공급업체 API:",
    successAddProduct: "성공적으로 추가됨",
    productAddFailed: "제품, 실패",
    oneClickAddPrice: "가격 일괄 추가",
    addingPrice: "가격 추가 중",
    productsWithoutPriceTip: "빨간색으로 표시된 자재는 공급업체 시스템에 가격이 없습니다. 공급업체 시스템에 이 자재의 가격을 추가해야 합니다",
    noNeedAddPrice: "가격을 추가할 필요가 없습니다",
    allProductsHavePrice: "모든 자재에 이미 가격이 있습니다",
    supplierIdError: "공급업체 ID 오류, 확인해주세요",
    successAddPrice: "성공적으로 추가됨",
    priceAddFailed: "가격, 실패",

    // GeneratePurchase 구매 주문 생성
    oneClickOrder: "일괄 주문",
    ordering: "주문 중",
    successGeneratePurchase: "성공적으로 생성됨",
    purchaseOrder: "구매 주문",
    generatePurchaseFailed: "구매 주문, 실패",
    purchaseOrderNumber: "구매 주문 번호",
    purchaseQuantity: "구매 수량",
    orderStatus: "주문 상태",
    ordered: "주문됨",
    finished: "완료됨",
    notOrdered: "주문되지 않음",
    acceptStatus: "수락 상태",
    accepted: "수락됨",
    oneClickAccept: "일괄 수락",
    accepting: "구매 주문 수락 중",
    noData: "데이터 없음",
    noPurchaseOrderToAccept: "수락할 구매 주문이 없습니다",
    successAccept: "성공적으로 수락됨",
    acceptFailed: "구매 주문, 실패",
    noPurchaseDataTip: "구매가 필요 없거나 이미 사전 구매 주문이 생성된 데이터는 구매 주문으로 처리되지 않습니다",
    swapSale: "전송",
    // SwapSaleOrder 전송
    noDataToTransfer: "전송할 데이터가 없습니다",
    noDataToTransferDesc: "구매가 필요 없거나 이미 사전 구매 주문이 생성된 데이터는 전송되지 않습니다",
    supplierApiLabel: "공급업체 API: ",
    fetchOrgInfoFailed: "조직 정보 가져오기 실패",
    orgLabel: "조직：",
    selectSupplierAndCustomer: "공급업체 조직과 최종 고객을 선택하세요",
    noMatchedProductData: "일치하는 제품 데이터가 없습니다",
    saleOrderTransferSuccess: "영업 주문 전송 성공",
    saleOrderNumber: "영업 주문 번호: ",
    saleOrderGenerateFailed: "영업 주문 생성 실패",
    selectSupplierFirst: "공급업체를 선택하세요",
    selectSupplierOrg: "공급업체 조직을 선택하세요",
    selectSupplierCustomer: "공급업체 최종 고객을 선택하세요",
    confirmGenerateSaleOrder: "영업 주문을 생성하시겠습니까?",
    generateSaleOrderForSupplier: "공급업체용 영업 주문 생성: ",
    swapEnd: "정보 매칭 실패, 주문 전환이 종료되었습니다.",
    noCustomerPrice: "빨간색으로 표시된 자재는 공급업체 시스템에 이 최종 고객 가격이 없습니다",
    plAddCustomerPrice: "공급업체 시스템에서 이 최종 고객의 자재 가격을 추가해 주십시오",
    noProducts: "빨간색으로 표시된 자재는 공급업체 시스템에 존재하지 않습니다",
    plAddProdictOne: "1. 공급업체 시스템에서 이러한 자재 정보를 추가하십시오",
    plAddProdictTwo: "2. 공급업체 시스템에서 이러한 자재의 상품 가격을 추가하십시오",
    closeSaleOrderTip: "연결된 판매 주문을 삭제하시겠습니까:",
    plAddSupplierPrice: "빨간색으로 표시된 자재에 이 공급업체 가격이 없습니다. 먼저 이 시스템에서 이러한 자재의 공급업체 가격을 유지 관리하십시오.",
    batchSelect: "문의서 일괄 선택",
    progress: "진행률",
    importQuotationExcel: "견적 Excel 가져오기",
    quotationImportPreview: "공급업체 견적 가져오기 미리보기",
    quotationImportRowNumber: "행 번호",
    quotationImportRequirementItemId: "요구사항 항목 ID",
    quotationImportSupplierCode: "공급업체 코드",
    quotationImportSupplierName: "공급업체 이름",
    quotationImportPrice: "가격",
    quotationImportMpq: "최소 포장",
    quotationImportStatus: "상태",
    quotationImportItemIdRequired: "요구사항 항목 ID는 필수입니다",
    quotationImportItemNotFound: "요구사항 항목 ID가 없거나 유효하지 않습니다",
    quotationImportProductMismatch: "요구사항 항목 ID와 재고 코드가 일치하지 않습니다",
    quotationImportSupplierRequired: "공급업체 코드는 필수입니다",
    quotationImportSupplierLoadFailed: "공급업체 데이터를 불러오지 못했습니다",
    quotationImportPriceInvalid: "가격은 0보다 큰 유효한 숫자여야 합니다",
    quotationImportMpqInvalid: "최소 포장은 0보다 큰 유효한 숫자여야 합니다",
    quotationImportNoMrd: "최종 납기를 결정할 MRD가 없습니다",
    quotationImportInvalidHeader: "파일 헤더가 올바르지 않습니다. 현재 상세 페이지에서 내보낸 파일을 사용하세요",
    quotationImportFileEmpty: "가져오기 파일에 처리할 데이터가 없습니다",
    quotationImportParseFailed: "가져오기 파일을 분석하지 못했습니다",
    quotationImportSubmitFailed: "공급업체 견적 추가에 실패했습니다",
    quotationImportReady: "제출 가능",
    quotationImportReselect: "파일 다시 선택",
    quotationImportHasErrors: "검증 오류가 있습니다. Excel을 수정한 후 다시 가져오세요",
    quotationImportSummary: "성공 {{success}}건, 실패 {{failed}}건",
    salePass: "정식 주문으로 전환",
    downloadTemplate: "템플릿 다운로드",
    inputTemp: "템플릿에서 입력",
    importTemplate: "요구사항 목록 가져오기 템플릿",
    invalidTemplate: "올바른 템플릿 파일을 선택해주세요",
    parseDataSuccess: "{{count}}개의 데이터를 성공적으로 구문 분석했습니다",
    atLeastOnePreOutGreaterThanZero: "적어도 하나의 사전 출고 수량이 0보다 커야 합니다",
    cusOrderQty: "고객 주문 수량",
    cusOrderQtyTip: "주문 전환",
    processFilter: "자재 공정 검색",
    delErrTip: "다음 자재는 출고된 수량이 존재하므로 삭제할 수 없습니다!",
    mixReplaced: "대체자재 혼합 사용",
    preOutDesc: "사전 출고 비고",
    prePickOutLimitAutoTip: "현재 사전 출고 수량은 유효 범위 내로 자동 제한됩니다",
    prePickOutRemainLimit: "남은 사전 출고 가능 수량",
    prePickOutStockLimit: "가용 재고 수량",
    prePickOutMaxLimit: "최대 입력 가능 수량",
    deductOutCount: "출고 수량 차감",
    inOrderDesc: "납품서 비고",
    plInventoryDesc: "납품서 비고를 입력하세요",
    noSale: "원본 판매 주문이 없습니다. 주문을 전환할 수 없습니다", oldApprove: "기존 승인 순서",
    newApprove: "신규 승인 순서",
    approveSaveTip: "이 문의서 승인 시 새 승인 순서도 저장됩니다",
    approveRemark: "승인 비고",
    matchLocType: "재고 매칭 로케이션 유형",
    rematch: "재고 매칭",
    rematchTip: "재고 매칭 위치 유형이 변경되었습니다. 재고를 다시 매칭하세요.",
    priceFloor: "구매 주문 가격 반올림",
    needReturn: "일부 출고 주문이 확인되었습니다!",
    needReturnTip: "다음 자재가 포함된 인출 주문은 반품 입고가 필요합니다",
    bomDatax: "시스템 BOM 데이터",
    templeData: "템플릿",
    xlsData: "판매 주문 BOM 파일",
    dataTypeTip: "BOM 매칭 데이터 소스 선택",
    dataTypeErr: "해당 판매 주문 BOM 데이터 분석 오류",
    dataTypeErrTip: "해당 판매 주문 BOM 데이터를 확인하거나 다른 BOM 데이터 소스로 전환하세요",
    pickErr: "새 사전 출고 주문: {{number}} 재고 할당 실패, 유지하시겠습니까?",
    pickErrTip: "사전 출고 주문: {{number}} 생성 성공",
    pickErrContent: "창고 관리에서 재고를 할당하세요",
    pickErrDel: "사전 출고 주문 생성 실패",
    itemDesc: "자재 비고",
    preOutErrTip: "수요 목록 {{number}} 생성 성공, 사전 출고 주문 생성 실패. 다시 시도하세요!",
    rePreOutAdd: "사전 출고 재시도",
    failPreTip: "수요 주문의 사전 출고 주문 생성 실패!",
    failPreTipDesc: "사전 출고 주문 생성 실패 시 수요 주문 수량이 잘못됩니다! 사전 출고 주문 실패를 처리하지 않으려면 이 수요 주문을 삭제하고 다시 실행하는 것을 권장합니다!",
};

export default ko;
